module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_arrow-6b2c2edecbe522afca17478894e3801d.svg";